<template>
    <div>
        <el-input v-if="!button" readonly
                  v-model="showName"
                  :size="size"
                  :placeholder="placeholder">
            <el-button @click="openSelect" slot="append">{{buttonText}}</el-button>
        </el-input>
        <Button v-if="button" type="primary" @click="openSelect">{{buttonText}}</Button>

        <Modal
                v-model="showEnterpriseDirectory"
                :title="modalTitle"
                :width="width">
            <RadioGroup v-model="selectEnterpriseDirectory" style="width: 100%">
                <Input v-model="query.name" style="width: 200px" clearable placeholder="请输入代理名称"></Input>
                <Button type="primary" @click="searchEnterpriseDirectory" style="margin-left: 10px">查询</Button>
                <el-table
                        v-if="tableData!=null&&tableData.length>0"
                        :data="tableData"
                        size="mini"
                        border
                        stripe
                        @row-click="rowClick"
                        :header-row-style="()=>{return 'color: #5c6b77'}"
                        :header-cell-style="()=>{return 'background: #f8f8f9;line-height:35px'}"
                        style="width: 100%;margin-top: 10px">
                    <el-table-column prop="name"
                                     align="center"
                                     width="100"
                                     :show-overflow-tooltip="true"
                                     label="选择">
                        <template slot-scope="scope">
                            <Radio :label="scope.row">
                                <span></span>
                            </Radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                     align="left"
                                     :show-overflow-tooltip="true"
                                     label="企业名称">
                    </el-table-column>
                </el-table>
                <avue-empty v-else style="margin-top: 10px"></avue-empty>
            </RadioGroup>

            <div slot="footer">
                <Row>
                    <Col span="18">
                        <div style="display: flex;justify-content: flex-start;">
                            <Page v-if="count>0" style="margin-bottom: 10px" transfer @on-change="pageChange"
                                  :page-size="10"
                                  @on-page-size-change="sizeChange"
                                  :current="query.current"
                                  prev-text="上一页"
                                  next-text="下一页" :total="count" show-elevator show-total show-sizer/>
                        </div>
                    </Col>
                    <Col span="6">
                        <Button @click="okClear">清空</Button>
                        <Button type="primary" @click="okSelect">选择</Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    </div>
</template>

<script>
    import appUtils from '@/utils/appUtils';
    import {pageEnterpriseDirectory,getEnterpriseDirectory} from '@/api/economy/enterpriseDirectory'

    export default {
        name: 'select-enterprise',
        props: {
            //值
            value: {
              type:Object
            },
            //显示姓名
            name: {},
            //展位信息
            placeholder: {
                default: '请选择'
            },
            //弹出层标题
            modalTitle: {
                default: '选择企业'
            },
            //弹出层宽度
            width: {
                default: '800'
            },
            //表单尺寸
            size: {
                default: 'small'
            },
            //按钮文字
            buttonText: {
                default: '选择'
            },
            button:{
                default:false
            },
            noId:{}
        },
        data() {
            return {
                //是否显示企业选择弹窗
                showEnterpriseDirectory: false,
                //列表数据
                tableData: []
                //数据总行数
                , count: 0
                // 企业查询条件
                , query: {
                    name: null,
                    size: 10,
                    current: 1,
                    enterpriseFlag:true
                },
                //显示姓名
                showName: null,
                //已选择企业
                selectEnterpriseDirectory: null
            }
        },
        watch: {
            name() {
                this.showName = this.name
            },
            value() {
                if (this.value == null) {
                    this.showName = null
                } else {
                    if (this.name == null) {
                        this.getEnterprise()
                    }
                }
                console.log("value-------",this.value)
            }
        },
        computed: {},
        methods: {
            /**
             * 根据ID获取企业
             */
            getEnterprise() {
                getEnterpriseDirectory(this.value.id).then(res => {
                    if (res.state && res.data != null) {
                        this.showName = res.data.name
                    }
                })
            },
            /**
             * 获取数据
             */
            getData() {
                this.selectEnterpriseDirectory = null
                let loading = appUtils.showLoading()
                if(this.noId!=null){
                    this.query.noIdList= this.noId.toString()
                }
              pageEnterpriseDirectory(this.query).then(res => {
                    appUtils.hideLoading(loading)
                    if (res.state) {
                        this.tableData = res.data.records
                        this.count = res.data.total
                    } else {
                        appUtils.showError(res.msg)
                    }
                }).catch(err => {
                    appUtils.hideLoading(loading)
                })
            },
            /**
             * 页数发生改变
             */
            pageChange(val) {
                this.query.current = val
                this.getData()
            },
            /**
             * 每页显示条数发生改变
             */
            sizeChange(val) {
                this.query.size = val
                this.query.current = 1
                this.getData()
            },
            /**
             * 打开选择企业
             */
            openSelect() {
                this.showEnterpriseDirectory = true
                this.getData()
            },
            /**
             * 确认选择企业
             */
            okSelect() {
                this.$emit('input', this.selectEnterpriseDirectory)
                this.$emit('on-change', this.selectEnterpriseDirectory)
                if (this.selectEnterpriseDirectory != null) {
                    let staff = this.tableData.filter(item => item.id == this.selectEnterpriseDirectory.id)
                    this.value = staff[0]
                    this.showName = staff[0].name
                } else {
                    this.showName = null
                }


                this.showEnterpriseDirectory = false
            },
            /**
             * 清空选择企业
             */
            okClear() {
                this.selectEnterpriseDirectory = null
                this.$emit('input', this.selectEnterpriseDirectory)
                this.$emit('on-change', this.selectEnterpriseDirectory)
                this.showName = null
                this.showEnterpriseDirectory = false
            },
            searchEnterpriseDirectory() {
                this.query.current = 1
                this.getData()
            },
            /**
             * 单元格点击事件
             * @param row
             * @param column
             * @param event
             */
            rowClick(row, column, event) {
                this.selectEnterpriseDirectory = row
            }
        },
        mounted() {

        },
    }
</script>
